import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useState, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { sentryError } from 'utils';

const useSendSignerReminder = (
  signingId: string,
  onSendReminder: (signingId: string) => void,
) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const sendReminder = useCallback(async () => {
    try {
      setIsLoading(true);

      await dataRoomApi.nda.sendNdaReminders(signingId);

      popSuccess(t('successfullysentNDA'));
      onSendReminder(signingId);
    } catch (e) {
      sentryError(e);
      popServerError(e);
    } finally {
      setIsLoading(false);
    }
  }, [signingId, t, onSendReminder, popSuccess, popServerError]);

  return { isLoading, sendReminder };
};

export default useSendSignerReminder;
